<template>
    <div v-loading="dataLoading">
        <RsStep :active="0" :steps="['创建专辑', '上传歌曲', '提交审核']"></RsStep>
        <div class="content-box first">
            <el-form :model="formData" ref="formData" label-position="top" :rules="rules" label-width="160px">
                <el-row :gutter="60">
                    <el-col :span="12">
                        <el-form-item prop="album.cover" label="封面" :rules="[{required: true, message: '请上传封面'}]">
                            <ImageUpload
                                :disabled="isEdit"
                                class="album-cover"
                                :minWidth="minWidth"
                                :minHeight="minHeight"
                                :url.sync="formData.album.cover"
                                :isWatermark="true"
                                :hasWatermark.sync="formData.album.hasWatermark"
                                accept="image/png,image/jpeg"
                                crop
                                @onSuccess="handleImageSuccess"
                            >
                                <div slot="tips">
                                    格式：JPG、JPEG、PNG
                                    <br />
                                    {{ ImageUploadTips }}
                                    <br />
                                    大小：不得大于15M
                                </div>
                            </ImageUpload>
                        </el-form-item>
                        <!-- <el-form-item prop="album.type" label="类型" :rules="[{ required: true, message: '请选择专辑类型' }]">
                            <el-select v-model="formData.album.type" :disabled="isEdit" placeholder="请选择类型">
                                <el-option label="专辑" :value="1" />
                                <el-option label="单曲" :value="2" />
                                <el-option label="EP" :value="3" />
                            </el-select>
                        </el-form-item> -->
                        <el-form-item prop="album.introduce" label="简介">
                            <el-input
                                :disabled="isEdit"
                                v-model="formData.album.introduce"
                                type="textarea"
                                placeholder="填写一段关于专辑的简介"
                                :rows="18"
                                :maxlength="10000"
                                show-word-limit
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="album.name" label="名称" :rules="[{required: true, message: '请输入名称'}]">
                            <el-input :disabled="isEdit" v-model="formData.album.name" placeholder="请输入名称" maxlength="250"></el-input>
                        </el-form-item>
                        <el-form-item prop="album.releaseEdition" label="专辑副标题">
                            <el-select
                                v-model="formData.album.releaseEdition"
                                allow-create
                                filterable
                                default-first-option
                                :clearable="true"
                                placeholder="请选择"
                            >
                                <el-option v-for="item in releaseEditionOptions" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="album.langCode" label="表演语言" :rules="[{required: true, message: '请选择表演语言'}]">
                            <el-select :disabled="isEdit" v-model="formData.album.langCode" placeholder="请选择表演语言">
                                <el-option v-for="(item, index) in allLangCode" :key="index" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="album.genreId" label="流派/风格" :rules="[{required: true, message: '请选择风格流派'}]">
                            <el-cascader
                                :disabled="isEdit"
                                v-model="formData.album.genreId"
                                :options="allGenre"
                                :props="{emitPath: false}"
                            ></el-cascader>
                        </el-form-item>
                        <el-form-item prop="album.dealStartDate" label="期望上线时间">
                            <HolidayDatePicker
                                v-model="formData.album.dealStartDate"
                                :disabled="isDealStartDateEdit"
                                :editable="false"
                            />
                            <!-- <el-date-picker
                                v-model="formData.album.dealStartDate"
                                type="datetime"
                                :disabled="isDealStartDateEdit"
                                placeholder="请选择期望上线时间"
                                value-format="timestamp"
                                format="yyyy-MM-dd HH:00"
                                :default-value="new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).getTime()"
                                popper-class="hideDatePicker"
                                :picker-options="pickerOptions"
                                style="width: 100%"
                                :editable="false"
                            /> -->
                        </el-form-item>
                        <el-form-item
                            v-if="$store.state.userType == 3"
                            prop="album.originalReleaseDate"
                            :rules="[{required: true, message: '请选择原始发行日期'}]"
                        >
                            <label slot="label">
                                原始发行日期
                                <p>填写已/将上线的首次日期</p>
                            </label>
                            <el-date-picker
                                v-model="formData.album.originalReleaseDate"
                                type="datetime"
                                :disabled="isEdit"
                                placeholder="请原始发行时间"
                                value-format="timestamp"
                                format="yyyy-MM-dd HH:00"
                                popper-class="hideDatePicker"
                                style="width: 100%"
                                :editable="false"
                            />
                        </el-form-item>
                        <ArtistSelectCard :main-artist.sync="formData.mainArtist" :is-other-artist="false" :disabled="isEdit" :display-lang-code="formData.album.displayLangCode" :third-party-platform-stats="thirdPartyPlatformStats"></ArtistSelectCard>
                    </el-col>
                </el-row>
                <el-form-item label="" style="text-align: center">
                    <el-button v-if="isCanEdit" type="primary" @click="onSubmit" :loading="btnLoading">下一步</el-button>
                    <el-button v-if="status == 12" :loading="btnLoading" type="info" @click="sendAlbumEdit(1)">发起修改</el-button>
                    <el-button v-if="status == 14" :loading="btnLoading" type="info" @click="sendAlbumEdit(2)">撤销修改</el-button>
                </el-form-item>
            </el-form>
        </div>
        <IssueService :visible.sync="issueServicevisible"></IssueService>
    </div>
</template>

<script>
import ArtistSelectCard from '../components/ArtistSelectCard';
import ImageUpload from '@/components/ImageUpload';
import {getLangCode, getGenre} from '@/api/common';
import IssueService from '../components/IssueService';
import HolidayDatePicker from '@/components/HolidayDatePicker';

export default {
    props: {
        albumId: {
            type: [Number, String],
            default: '',
        },
    },
    components: {ImageUpload, IssueService, ArtistSelectCard, HolidayDatePicker},
    data() {
        return {
            dataLoading: false,
            formData: {
                album: {
                    hasWatermark: 1,
                    type: 1,
                },
            },
            pickerOptions: {
                disabledDate(time) {
                    const endDate = new Date(Date.now() + 4 * 24 * 60 * 60 * 1000);
                    endDate.setHours(0, 0, 0, 0);
                    return time.getTime() < endDate.getTime();
                },
            },
            rules: {
                mainArtist: [{type: 'array', required: true, message: '至少添加一位艺人，主要的演唱艺人'}],
            },
            btnLoading: false,
            allLangCode: [],
            allGenre: [],
            // 专辑状态 | 未提交 10、待审核 11、 审核通过 12、审核未通过 13、修改中 14、已删除 15、修改待审核 16
            status: 10,
            statusMsg: '',
            reFresh: false,
            issueServicevisible: false,
            releaseEditionOptions: ['豪华版', 'Remastered', '特别版', '纪念版', '影视专辑', '精选集', '现场'],
            thirdPartyPlatformStats: []
        };
    },
    computed: {
        // 专辑是否可以修改（未提交、审核未通过、修改中状态下允许修改）
        isCanEdit() {
            return this.status === 10 || this.status === 13 || this.status === 14;
        },
        isEdit() {
            return this.status === 12 ? true : false;
        },
        isDealStartDateEdit() {
            if (this.status === 12) return true;
            if (this.formData.album && this.formData.album.spLinkStatus && this.formData.album.spLinkStatus !== 0) return true;
            return false;
        },
        ifLimitAlbumForShowStart() {
            return this.$store.state.userData && this.$store.state.userData.ifLimitAlbumForShowStart;
        },
        minWidth() {
            return this.$store.state.userData.userInfo?.coverSetting === 1 ? 500 : 1400;
        },
        minHeight() {
            return this.$store.state.userData.userInfo?.coverSetting === 1 ? 500 : 1400;
        },
        ImageUploadTips() {
            return this.$store.state.userData.userInfo?.coverSetting === 1 ? '尺寸：1:1，不小于500*500像素，但不能超过6000*6000像素' : '尺寸：1:1，不小于1400*1400像素，但不能超过6000*6000像素';
        },
    },
    created() {
        this.getAllLangCode();
        this.getAllGenre();
        if (this.albumId) {
            this.getDataDetail();
        } else {
            this.reFresh = true;
        }
    },
    methods: {
        //返回
        goBack() {
            this.$router.go(-1);
        },
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: '/album/view/album_info',
                params: {albumId: this.albumId},
                method: 'post',
            })
                .then((res) => {
                    const {state, msg, result} = res.data;
                    if (state == 1) {
                        this.formData = {
                            album: {
                                ...result.albumVo.album,
                                hasWatermark: result.albumVo.album.hasWatermark || 1,
                            },
                            mainArtist: result.albumVo.albumArtists,
                        };
                        this.status = result.albumVo.album.status;
                        this.statusMsg = res.data.result.alertInfo;
                        this.thirdPartyPlatformStats = result.thirdPartyPlatformStats || [];
                    } else {
                        this.$message.error(msg || '获取数据失败,请重试');
                    }
                })
                .catch(() => {
                    this.$message.error('获取数据失败,请重试');
                })
                .finally(() => {
                    this.dataLoading = false;
                    this.reFresh = true;
                });
        },
        //图片上传成功后执行 需要重置海报的水印图
        handleImageSuccess(data) {
            if (this.formData.album.cover) {
                this.formData.album.coverS = data.urlS;
                this.$refs['formData'].clearValidate('album.cover');
            }
        },
        //获取表演语言
        getAllLangCode() {
            getLangCode().then((res) => {
                this.allLangCode = res;
            });
        },
        //获取风格
        getAllGenre() {
            getGenre().then((res) => {
                this.allGenre = res;
            });
        },
        commit() {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                const vip = (this.$store.state.verify && this.$store.state.verify.vip) || {};
                const _msg = vip.isPaid == 0 ? '未加入会员，请先成为会员' : vip.isExpired == 1 ? '会员已过期，请续费' : '';
                if (vip.isPaid == 0 || vip.isExpired != 0) {
                    const flag = await this.$confirm(_msg, '提示', {
                        confirmButtonText: '马上去',
                        cancelButtonText: '稍后',
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        center: true,
                    }).catch(() => 'cancel');
                    if (flag === 'cancel') return reject();
                    resolve(false);
                } else {
                    resolve(true);
                }
            });
        },
        //表单提交
        onSubmit() {
            this.$refs['formData'].validate(async (valid) => {
                if (valid) {
                    const {userState} = this.$store.getters;
                    if (userState != 6 && this.ifLimitAlbumForShowStart != 1) {
                        const {userType} = this.$store.state;
                        // 个人还是企业
                        if (userType == 1) {
                            return (this.issueServicevisible = true);
                        } else {
                            return this.$confirm('您的发行服务已经到期，目前企业发行续费服务已经停止，请联系客服进行专辑修改', '温馨提示', {
                                confirmButtonText: '知道了',
                                showCancelButton: false,
                                center: true,
                                type: 'warning',
                            });
                        }
                    }

                    this.btnLoading = true;
                    const albumArtists = this.formData.mainArtist.map((row, index) => {
                        if (!row.sort) row.sort = index;
                        return row;
                    });
                    let _formData = {album: this.formData.album, albumArtists: albumArtists};
                    this.$request({
                        url: '/album/saveEpAlbum',
                        method: 'POST',
                        data: _formData,
                        formData: false,
                    })
                        .then((res) => {
                            //处理成功回调
                            const {state, msg, result} = res.data;
                            if (state && state == 1) {
                                const route = {
                                    path: `/manage/album/songList/${result}`,
                                    query: {
                                        redirect: `/manage/album/info/${result}`,
                                        hasAuditPassRecord: this.$route.query.hasAuditPassRecord,
                                    },
                                };
                                result ? this.$router.push(route) : this.$router.replace(route);
                            } else {
                                return this.$message.error(msg || '操作失败');
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        /**
         * 发起\撤销修改
         * @param {Number} type  操作方式 1=修改 2=撤销
         */
        async sendAlbumEdit(type) {
            if (type == 1) {
                const flag = await this.$confirm(
                    this.albumStatus == 4 ? '可能会让你修改后的信息，无法及时同步到各个平台' : '发起修改后，可能会影响正常上线时间',
                    '修改专辑',
                    {
                        center: true,
                        confirmButtonText: '确认修改',
                    }
                );
                if (flag === 'cancel') return;
            }
            this.btnLoading = true;
            this.$request({
                url: this.status == 12 ? '/album/up/launch' : '/album/up/cancel',
                method: 'POST',
                data: {albumId: this.albumId},
            })
                .then((res) => {
                    //处理成功回调
                    const {state, msg} = res.data;
                    if (state && state == 1) {
                        this.getDataDetail();
                    } else {
                        return this.$message.error(msg || '操作失败');
                    }
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
    },
};
</script>
